import React from 'react';
import Icon from './Icon';

interface HeaderProps {
  title: string;
  onBack?: () => void;
  action?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, onBack, action }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '14px 20px',
    borderBottom: '1px solid var(--glass-border)',
    flexShrink: 0,
  }}>
    {onBack && (
      <button
        onClick={onBack}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '2px 6px 2px 0',
          color: 'var(--teal)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Icon name="back" size={22} color="var(--teal)" />
      </button>
    )}
    <span style={{
      fontWeight: 700,
      fontSize: 18,
      flex: 1,
      color: 'var(--text0)',
      letterSpacing: '-0.02em',
    }}>
      {title}
    </span>
    {action}
  </div>
);

export default Header;
